import React from 'react';

export default ({ status } : { status: string }) => {
  return (<>
    <div style={{textAlign: 'left', verticalAlign: 'middle', display: 'inline-block', textTransform: 'uppercase'}}>
      {status === 'Complete' ?
        <div style={{color:'rgb(79, 147, 0)'}}><strong className="mdi mdi-check-circle"/>{'   Complete'}</div> :
        status === 'In Progress' ?
        <div className="saving" style={{color: '#00658B'}}>
          <span>.</span><span>.</span><span>.</span><span>.</span><span>.</span><label style={{paddingLeft: '10px'}}>IN
          PROGRESS</label></div> : <i style={{color: '#535353', fontWeight: 'lighter'}}>Unstarted</i>  }
    </div>
  </>);
};
